import React from 'react';
import {OrderType} from "../../../../services/Api/types";
import MultistorePlaceCardOrderType from "./MultistorePlaceCardOrderType";

interface Props {
    orderTypes: OrderType[];
}

const MultistorePlaceCardOrderTypes = ({orderTypes}: Props) => {
    if (orderTypes.length === 0) return <></>;

    return (
        <div className="place-order-types">
            {
                orderTypes.map(orderType => (<MultistorePlaceCardOrderType key={orderType} orderType={orderType}/>))
            }
        </div>
    )
}

export default MultistorePlaceCardOrderTypes;